import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Eye } from "lucide-react";
import { ShopCard } from "../components/preview/ShopCard";
import { PdfViewer } from "../components/preview/PdfViewer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Step = ({ n, title, sub, children, id }) => (
  <section data-testid={id} className="py-14 border-t border-stone-200">
    <div className="text-[11px] uppercase tracking-[0.3em] text-[#9A7B2C]">Step {n}</div>
    <h2 className="font-display text-3xl text-[#2B2A26] mt-1">{title}</h2>
    <p className="text-sm text-stone-500 mt-1 mb-8">{sub}</p>
    {children}
  </section>
);

export default function CustomerPreview() {
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  const base = `${API}/preview/${token}`;
  useEffect(() => { axios.get(base).then((r) => setP(r.data)).catch(() => setErr("This preview link has expired or was turned off.")); }, [base]);
  if (err) return <div data-testid="preview-error" className="min-h-screen flex items-center justify-center text-stone-500">{err}</div>;
  if (!p) return <div className="min-h-screen bg-[#F7F5F0]" />;
  return (
    <div data-testid="customer-preview" className="min-h-screen bg-[#F7F5F0]">
      <div className="sticky top-0 z-10 bg-[#2B2A26] text-[#E9D48F] text-xs tracking-[0.2em] uppercase px-6 py-3 flex items-center gap-2">
        <Eye size={14} /> Customer preview {p.published ? "· live on the shop" : "· not published yet"}
      </div>
      <main className="max-w-6xl mx-auto px-6 lg:px-12 pb-20">
        <header className="pt-12 pb-6">
          <h1 data-testid="preview-title" className="font-display text-4xl sm:text-5xl text-[#2B2A26]">{p.title}</h1>
          <p className="text-stone-500 mt-2">What a buyer sees, from the shop listing to the guide on their phone.</p>
        </header>
        <Step n={1} id="preview-step-shop" title="The shop listing" sub="As the card appears on pbtravelangel.com">
          <div className="grid md:grid-cols-[340px_1fr] gap-10 items-start">
            <ShopCard p={p} base={base} />
            <div className="text-sm text-stone-600 leading-relaxed max-w-xl whitespace-pre-line" data-testid="preview-description">{p.description}</div>
          </div>
        </Step>
        <Step n={2} id="preview-step-pdf" title="The PDF kit" sub="Page by page, exactly as it downloads">
          <PdfViewer base={base} />
        </Step>
        {!p.pdf_only && (
          <Step n={3} id="preview-step-app" title="The phone app" sub="The interactive guide they keep on their phone — tap around">
            <div className="flex justify-center">
              <div className="w-[390px] h-[800px] rounded-[48px] bg-[#1d1c19] p-3 shadow-2xl">
                <iframe data-testid="preview-app-frame" title="Phone app" src={`${base}/app`} className="w-full h-full rounded-[38px] bg-white" />
              </div>
            </div>
          </Step>
        )}
      </main>
    </div>
  );
}
